<template>
  <div :class="{'td2-body-bg':tdType == 'body'}" class="my-td2-box" :style="'width:' + boxWidth + 'px;'">
    <div class="my-td2-box-inner" ref="td" :class="{'overflow':overflow}">
      <slot></slot>
    </div>
  </div>
</template>
<script>
// <Td2></Td2>
export default {
  name: 'Td2',
  props: {
    width: {
      type: String,
      default: '0'
    },
    tdType: {
      type: String,
      default: 'body'
    }
  },
  computed: {
    boxWidth () {
      let width = 0
      // tdType
      // body title

      if (Number(this.width) > 0) {
        width = this.width
        return width
      }

      return 150
    }
  },
  data () {
    return {
      overflow: false
    }
  },

  methods: {
    // handleClick (evt) {
    //   this.$emit('click', evt)
    // }
  },
  mounted () {
    let td = this.$refs.td
    let height = window.getComputedStyle(td).height
    let num = height.substr(0, height.length - 2)
    //

    if (Number(num) > 20) {
      this.overflow = true
      td.title = td.innerHTML
    }
  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-td2-box{
  vertical-align: top;
  box-sizing:border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  font-size:14px;
  display: inline-block;
  line-height: 18px;
  padding: 18px 0px;
  margin: 0 auto;
  min-height: 54px;
  .my-td2-box-inner{
    box-sizing:border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding: 0 20px;
  }
  .overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>
